<template>
  <section class="all-cases-view" v-loading="loading">
    <div class="container-default">
      <div class="listings-navbar">
        <el-row>
          <el-col :lg="11">
            <ul class="d-flex list-items-group-15 barcode-print">
              <li>
                <div class="form-element input-with-icon search-input-lg">
                  <el-input
                    placeholder="Accession / Patient Name"
                    v-model="search_string"
                    @input="getAutoCompleteCases()"
                    :clearable="true"
                  ></el-input>
                  <span>
                    <img
                      src="@/assets/images/icons/search-icon-with-bg-red.svg"
                      alt="icon"
                      class="img-fluid icon"
                    />
                  </span>
                </div>
              </li>
            </ul>
          </el-col>
          <el-col :lg="13">
            <ul
              class="d-flex flex-wrap justify-content-end list-items-group-15"
            >
              <li v-if="hasPermission('cases', 'create')">
                <el-button
                  class="btn button-with-icon"
                  @click="onReportsExport"
                >
                  <span class="mr-8">
                    <img
                      src="@/assets/images/icons/export-icon-with-bg-blue.svg"
                      alt="icon"
                      class="inactive"
                    />
                    <img
                      src="@/assets/images/icons/export-icon-white.svg"
                      alt="icon"
                      class="active"
                    />
                  </span>
                  <span>Export</span>
                </el-button>
              </li>
            </ul>
          </el-col>
        </el-row>
      </div>
      <div class="primary-content-view-new">
        <div
          class="listings listings__table listings__all-cases"
          id="all-cases-listings"
        >
          <el-table
            :data="getAllMileageCases.data"
            height="calc(100vh - 185px)"
            :default-sort="{
              prop: orderBy,
              order: orderType == 'asc' ? 'ascending' : 'descending',
            }"
          >
            <el-table-column
              fixed="left"
              prop="accession_id"
              label="ACCESSION ID"
            >
              <template #default="scope">
                <div class="name-accession">
                  {{ scope.row.accession_id }}
                </div>
              </template>
            </el-table-column>
            <el-table-column label="Residence Type">
              <template #default="scope">
                <span> {{ scope.row.residence_type || "--" }}</span>
              </template>
            </el-table-column>
            <el-table-column label="Encore Miles">
              <template #default="scope">
                <span> {{ scope.row.encore_miles || "--" }}</span>
              </template>
            </el-table-column>
            <el-table-column label="Technician">
              <template #default="scope">
                <span> {{ scope.row.technician || "--" }}</span>
              </template>
            </el-table-column>
            <el-table-column
              label="LAB DROP OFF"
              prop="lab_drop_off_date"
              sortable="custom"
            >
              <template #default="scope">
                <div v-if="scope.row.lab_drop_off_date" class="d-flex">
                  <div class="date pr-10">
                    {{
                      momentWithTimezone(
                        scope.row.lab_drop_off_date,
                        "MM-DD-yyyy"
                      )
                    }}
                  </div>
                </div>
              </template>
            </el-table-column>
            <el-table-column
              label="RXNT SEND DATE"
              prop="rnxt_sent_date"
              sortable="custom"
            >
              <template #default="scope">
                <div v-if="scope.row.rnxt_sent_date" class="d-flex">
                  <div class="date pr-10">
                    {{
                      momentWithTimezone(
                        scope.row.rnxt_sent_date,
                        "MM-DD-yyyy hh:mm A"
                      )
                    }}
                  </div>
                </div>
                <div v-else>
                 --
                </div>
              </template>
            </el-table-column>
            <el-table-column
              prop="action"
              label="Actions"
              width="110"
              fixed="right"
            >
              <template #default="scope">
                <ul class="listings__action-buttons">
                  <li @click="goToMileageCaseView(scope.row)">
                    <el-button class="view-button" title="View Case">
                      <img
                        class="action-active"
                        src="@/assets/images/icons/actions/view-icon.svg"
                        alt="icon"
                      />
                      <img
                        class="action-inactive"
                        src="@/assets/images/icons/actions/view-inactive.svg"
                        alt="icon"
                      />
                    </el-button>
                  </li>
                  <li>
                    <el-button
                      title="Archive"
                      class="delete-button"
                      @click="onDelete(scope.row._id)"
                    >
                      <img
                        class="action-active"
                        src="@/assets/images/icons/actions/delete-active.svg"
                        alt="icon"
                      />
                      <img
                        class="action-inactive"
                        src="@/assets/images/icons/actions/delete-deactive.svg"
                        alt="icon"
                      />
                    </el-button>
                  </li>
                  <li v-if="this.isBillingInfoValid(scope.row.case_id)">
                    <el-button
                      v-if="scope.row.rnxt_sent"
                      title="RESENT TO RXNT"
                      class="delete-button"
                      @click="sendMileageToRXNT(scope.row._id)"
                    >

                    <img
                        class="action-active"
                        src="@/assets/images/icons/actions/re-sent-rxnt-active-icon-new.svg"
                        alt="icon"
                      />
                      <img
                        class="action-inactive"
                        src="@/assets/images/icons/actions/re-sent-rxnt-inactive-icon-new.svg"
                        alt="icon"
                      />
                    </el-button>
                    <el-button v-else
                      title="SEND TO RXNT"
                      class="delete-button"
                      @click="sendMileageToRXNT(scope.row._id)"
                    >
                    <img
                        class="action-active"
                        src="@/assets/images/icons/actions/sent-rxnt-active-icon-new.svg"
                        alt="icon"
                      />
                      <img
                        class="action-inactive"
                        src="@/assets/images/icons/actions/sent-rxnt-inactive-icon-new.svg"
                        alt="icon"
                      />
                    </el-button>
                  </li>
                </ul>
              </template>
            </el-table-column>
          </el-table>
        </div>
        <div class="listings listings__pagination">
          <el-pagination
            v-model:currentPage="page"
            v-model:page-size="pageSize"
            :page-sizes="[25, 50, 75, 100]"
            layout=" prev, pager, next, jumper, sizes ,total"
            :total="getAllMileageCases.total"
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
          />
        </div>
      </div>
    </div>
    <ExportMileageCases
      v-if="exportReportsDialogVisisble"
      v-on:close="exportReportsDialogVisisble = false"
    >
    </ExportMileageCases>
  </section>
  <ResonForChange
    v-if="takeReasonDialog"
    v-on:close="takeReasonDialog = false"
    v-on:reasonSubmit="deleteCase"
    title="Reason for Archive"
  ></ResonForChange>
</template>

<script>
import { mapGetters } from "vuex";
import moment from "moment";
import { defineAsyncComponent } from "vue";
import caseConstants from "@/config/constants/caseConstants";
import { casesExtraSearchOptions } from "@/config/constants/searchConstants";
import UserPermissionsHelper from "@/mixins/UserPermissionsHelper";
import caseDataHelper from "@/mixins/caseDataHelper";
import FilterHelper from "@/mixins/FilterHelper";
import AppHelper from "@/mixins/AppHelper";
const ExportMileageCases = defineAsyncComponent(() =>
  import("@/components/cases/ExportMileageCases")
);
const ResonForChange = defineAsyncComponent(() =>
  import("@/components/misc/ResonForChange")
);
import {
  successNotification,
  errorNotification,
} from "@/helpers/notifications";
export default {
  components: {
    ExportMileageCases,
    ResonForChange,
  },
  computed: {
    ...mapGetters("cases", [
      "getAllMileageCases",
      "getMileageCaseDeleteStatus",
      "getCaseDeleteError",
      "getSendMileageCaseToRXNTStatus"
    ]),
    ...mapGetters("auth", ["getAuthenticatedUser"]),

    ...mapGetters("profile", ["getProfileData"]),
    ...mapGetters("errors", ["getErrors", "getError"])
  },
  mixins: [FilterHelper, UserPermissionsHelper, AppHelper, caseDataHelper],
  data() {
    return {
      page: 1,
      pageSize: 25,

      search_string: "",

      accession_id: "",
      patient_name: "",

      loading: false,
      orderBy: "created_at",
      orderType: "desc",

      exportReportsDialogVisisble: false,

      searchQuery: "",
      requestArchiveCase: "",
      takeReasonDialog: false,
    };
  },
  mounted() {
    this.initData();
  },
  methods: {
    isBillingInfoValid(billing) {
      return billing && billing.billing_info && 
        typeof billing.billing_info === 'object' && 
        Object.keys(billing.billing_info).length > 0;
    },
    async sendMileageToRXNT(mileage){
      try {
        this.loading = true;
        let params = {
          mileage_id:mileage
        }
        await this.$store.dispatch("cases/sendMileageCasesToRXNT",params)
        if(this.getSendMileageCaseToRXNTStatus){
          successNotification("Mileage case moved to RXNT successfully")
          await this.fetchMileageCases();
        } else {
          errorNotification(this.getError || "Error while moving mileage case to RXNT")
        }
        this.loading = false;
      } catch(err){
        this.loading = false;
        console.log(err)
      } finally {
        this.loading = false;
      }
    },
    onDelete(id) {
      this.requestArchiveCase = id;
      this.takeReasonDialog = true;
    },
    async deleteCase(reason) {
      try {
        this.loading = true;
        await this.$store.dispatch("cases/deleteMileageCase", {
          case_id: this.requestArchiveCase,
          delete_reason: reason,
        });
        if (this.getMileageCaseDeleteStatus) {
          successNotification("Case archived successfully");
          this.requestArchiveCase = "";
          await this.fetchMileageCases();
        } else {
          errorNotification(
            this.getCaseDeleteError || "Error while deleting case"
          );
        }

        this.loading = false;
      } catch (err) {
        this.loading = false;
        console.log(err);
      }
    },
    async onReportsExport() {
      this.loading = true;

      this.exportReportsDialogVisisble = true;
      this.loading = false;
    },

    async initData() {
      this.setQueryParamsData();
      this.loading = true;

      await this.fetchMileageCases();
      this.loading = false;
    },

    setQueryParamsData() {
      this.page = this.$route.query.selectedPage
        ? parseInt(this.$route.query.selectedPage)
        : 1;
      this.pageSize = this.$route.query.selectedPageSize
        ? parseInt(this.$route.query.selectedPageSize)
        : 25;
      if (this.$route.query.selectedString) {
        this.search_string = this.$route.query.selectedString;
      }
    },

    prepareParams() {
      const params = {
        page: this.page,
        limit: this.pageSize,
      };
      if (this.search_string) {
        params.search_string = this.search_string;
      }

      return params;
    },

    getAutoCompleteCases() {
      setTimeout(() => {
        this.page = 1;
        this.fetchMileageCases();
      }, 600);
    },
    handleSizeChange(size) {
      this.pageSize = size;
      this.page = 1;

      this.fetchMileageCases();
    },

    handleCurrentChange(page) {
      this.page = page;

      this.fetchMileageCases();
    },
    handleCurrentChangeCaseType(page) {
      this.page = page;
      this.test_info = [];
      this.fetchMileageCases();
    },

    async fetchMileageCases() {
      try {
        let params = this.prepareParams();
        this.loading = true;
        await this.$store.dispatch("cases/fetchAllMileageCases", params);
        this.updateQueryParams(params);
        this.loading = false;
      } catch (error) {
        this.loading = false;
        console.log(error);
      }
    },

    updateQueryParams(params) {
      let selectedParams = {
        selectedPage: params.page,

        selectedString: params.search_string,

        selectedPageSize: params.limit,
      };
      this.updateQueryParam(this.$route.name, selectedParams);
    },
    goToMileageCaseView(data) {
      this.$router.push({
        name: "MilageCaseView",
        params: { case_id: data.case_id._id, m_id: data._id },
        query: { ...this.$route.query, redirectRoute: this.$route.name },
      });
    },
  },
};
</script>

<style lang="scss">
.test-reports {
  display: flex;
  align-items: center;
  padding: 4px 5px;
  .regular-reports {
    &.single-report {
      margin-left: 20px;
    }
    h5 {
      color: #0a5da6;
      font-size: 14px;
      span {
        color: #bdbdbd;
      }
    }
  }
  .repots {
    h5 {
      color: #0a5da6;
    }
  }
}

.test-tabs {
  padding: 0;

  .el-tabs__active-bar {
    height: 3px;
    background-color: #0a5da6;
    border-radius: 25px;
  }
  .el-tabs__item.is-active {
    color: #0a5da6;
    font-weight: 600;
  }

  .el-tabs__item {
    color: #828282;
  }
  .el-tabs__nav-scroll {
    padding: 0 18px;
  }

  .types {
    padding: 0 5px;
    .case-type {
      &.view-reports-dialog {
        .el-button {
          width: 100%;
          min-height: 36px;
          padding: 0 17px;
          background-color: #f2f6f9;
          border: 1px dashed #bababc;

          span {
            display: flex;
            justify-content: center;
            align-items: center;
            img {
              margin-right: 6px;
            }
            p {
              margin-left: 8px;
              color: #828282;
            }
          }
        }
      }
      .el-input__inner {
        height: 36px;
        border: 1px solid rgba(86, 204, 242, 0.8);
      }
    }
    .btn {
      margin-top: 23px;
      .el-button {
        min-height: 36px;
        padding: 8px 24px;
        font-size: 14px;
        font-weight: 600;
        border-radius: 7px;
      }
    }
  }
  .mark {
    margin-left: 15px;
  }
  .panel {
    .documents {
      display: none;
    }
    .el-table__header {
      color: rgba(0, 0, 0, 0.8);
      // background: #e5e5e5;
      border-spacing: 0 5.5px;
      border-radius: 25px;
    }
    .el-table {
      background: rgb(238, 242, 245);
      .el-table__cell {
        padding: 5px 0;
      }
      .el-table__header-wrapper {
        border-radius: 10px;
      }
      .el-table__body-wrapper {
        border-radius: 6px;
      }
      .el-table__cell {
        .cell {
          font-weight: 500;
        }
      }
    }
    .el-table thead {
      color: rgba(0, 0, 0, 0.8);
    }
    .physician-btn {
      .el-switch .el-switch__core {
        width: 34px !important;
        height: 15px;
        background-color: #0a5da6;
        border: none;
        .el-switch__action {
          top: 3px;
          left: 2px;
          width: 9px;
          height: 9px;
        }
      }
      .el-switch__label.is-active {
        color: #0a5da6;
      }
      .el-switch.is-checked {
        .el-switch__core {
          width: 34px !important;
          height: 15px;
          background-color: #4bb543 !important;
          border: none;
        }
        .el-switch__action {
          top: 2.2px;
          left: 38.5px;
          width: 10px;
          height: 10px;
        }
      }
    }
    .title {
      color: #2f80ed;
      img {
        color: #eb5757;
        vertical-align: middle;
      }
    }
  }
  .action-test-icons {
    display: flex;
    li {
      margin-right: 10px;
      .el-button {
        min-height: auto;
        padding: 0;
        background: none;
        border: none;
        transition: all 0.2s;

        &:hover {
          background-color: #eef2f5;
        }
        &:active {
          background-color: #eef2f5;
        }
        &:focus {
          background-color: #eef2f5;
        }
        img {
          color: red;
          &:hover {
            color: #0a5da6;
          }
        }
      }
    }
  }
}
.documents {
  padding: 0 20px;
  .el-tabs__item.is-active {
    color: #0a5da6;
    font-weight: 500;
  }
  .el-tabs__active-bar {
    background-color: #0a5da6;
    border-radius: 25px;
  }
  .document-container {
    display: grid;
    align-items: center;

    gap: 10px;
    grid-template-columns: 230px 230px;
  }
  .document-cell {
    display: grid;
    align-items: center;
    padding: 0 0.3rem;
    background-color: #fff;
    border: 1px solid #56ccf2;
    border-radius: 7px;

    grid-template-columns: 9% 75% 8% 10%;
    img {
      width: 18px;
      height: 18px;
    }
    .cancel {
      width: 15px;
      height: 15px;
    }
    p {
      margin-bottom: 0;
      font-size: 14px;
      font-weight: 500;
    }
    .demo-progress {
      .el-progress--line {
        width: 230px;
        .el-progress-bar__outer {
          height: 5px !important;
          background-color: #9ae0f7;
        }
        .el-progress-bar__inner {
          height: 5px;
          background-color: #2d9cdb;
        }
      }
      .el-progress__text {
        color: #828282;
      }
    }
  }
  .document-cell {
    display: grid;
    align-items: center;
    padding: 0 0.3rem;
    background-color: #fff;
    border: 1px solid #56ccf2;
    border-radius: 7px;

    grid-template-columns: 9% 80% 8% 10%;
    img {
      width: 18px;
      height: 18px;
    }
    .cancel {
      width: 15px;
      height: 15px;
    }
    p {
      font-size: 14px;
      font-weight: 500;
    }
  }
}
.listings-navbar {
  .barcode-print {
    .el-button--small {
      padding: 7px 15px;
      border-radius: 8px;
      &:hover {
        color: #4f4f4f;
        background: #fff;
        box-shadow: none;
        border: 1px solid #dedbdb;
      }
      &:focus {
        color: #4f4f4f;
        background: #fff;
        box-shadow: none;
        border: 1px solid #dedbdb;
      }
      &:active {
        color: #4f4f4f;
        background: #fff;
        box-shadow: none;
        border: 1px solid #dedbdb;
      }
    }
    .bulk-assign-btn {
      padding: 10px;
      color: #273480;
      font-weight: 500;
      text-transform: uppercase;
      background: #ffffff;
      border: 1px solid #dedbdb;
      border-radius: 6.4px;
      transition: all 0.2s ease-in-out;
      &:hover {
        background: #273480;
        color: #fff;
      }
    }
  }
}
.btn-synced {
  min-width: 100px;
  height: auto;
  min-height: 20px;
  padding: 6px 5px;
  color: #4bb543;
  font-size: 12px !important;
  font-weight: 500 !important;
  line-height: 1;
  letter-spacing: 0 !important;
  text-align: center;
  border: 0.6px solid #4bb543;
  border-radius: 4px !important;
  &:hover,
  &:active,
  &:focus {
    background: #f2f2f2;
    border: 0.6px solid #4bb543;
    color: #4bb543;
  }
}
.btn-sync {
  min-width: 100px;
  height: auto;
  min-height: 20px;
  padding: 6px 5px;
  color: #5162fd;
  font-size: 12px !important;
  font-weight: 500 !important;
  line-height: 1;
  letter-spacing: 0 !important;
  text-align: center;
  border: 0.6px solid #5162fd;
  border-radius: 4px !important;
  &:hover,
  &:active,
  &:focus {
    background: #f2f2f2;
    border: 0.6px solid #5162fd;
    color: #5162fd;
  }
}
.btn-processing {
  min-width: 100px;
  height: auto;
  min-height: 20px;
  padding: 6px 5px;
  color: #f28b0c;
  font-size: 12px !important;
  font-weight: 500 !important;
  line-height: 1;
  letter-spacing: 0 !important;
  text-align: center;
  border: 0.6px solid #f28b0c;
  border-radius: 4px !important;
  &:hover,
  &:active,
  &:focus {
    background: #f2f2f2;
    border: 0.6px solid #f28b0c;
    color: #f28b0c;
  }
}
</style>
